import { gql } from '@apollo/client'
import { RegisterPatientInput } from '../types'

export type IRegisterPatientParams = {
  input: RegisterPatientInput
}

export type IRegisterPatientResponse = any

const registerPatientMutation = gql`
  mutation RegisterPatient($input: RegisterPatientInput!) {
    registerPatient(input: $input) {
      ... on Patient {
        id
      }
      ... on UnrecoverableError {
        resourceTypename
        errorMessage
        unknownId
      }
    }
  }
`

export default registerPatientMutation
